// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container__LXod9","tabs":"Info_tabs__Rd2vz","tabItem":"Info_tabItem__Ev7z5","active":"Info_active__3prwu","content":"Info_content__z4O87"};